// ------------------------------------------------------------------------
// preload
// ----- BOTH
// ------------------------------------------------------------------------
const preload = () =>{


  $('body').addClass('preload');

  $(window).on('load' , function() {
    $("body").removeClass("preload");
  });

};

export {
  preload,
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js